var userAgent = navigator.userAgent.toLowerCase(),

  $document = $(document),
  $window = $(window),
  $html = $("html"),

  isDesktop = $html.hasClass("desktop"),
  isFirefox = userAgent.indexOf('firefox') > -1,
  isIE = userAgent.indexOf("msie") != -1 ? parseInt(userAgent.split("msie")[1]) : userAgent.indexOf("trident") != -1 ? 11 : userAgent.indexOf("edge") != -1 ? 12 : false,
  isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
  isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0,
  isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
  isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

AOS.init({
  easing: 'ease-in-out-sine',
  disable: 'mobile',
});

/** ON HOVER DROPDOWN MENU */
/** https://stackoverflow.com/questions/42183672/how-to-implement-a-navbar-dropdown-hover-in-bootstrap-v4 */
function toggleDropdown (e) {
  const _d = $(e.target).closest('.dropdown'),
      _m = $('.dropdown-menu', _d);
  setTimeout(function(){
    const shouldOpen = e.type !== 'click' && _d.is(':hover');
    _m.toggleClass('show', shouldOpen);
    _d.toggleClass('show', shouldOpen);
    $('[data-toggle="dropdown"]', _d).attr('aria-expanded', shouldOpen);
  }, e.type === 'mouseleave' ? 50 : 0);
}
$('body')
  .on('mouseenter mouseleave','.nav-item.dropdown',toggleDropdown)
  .on('click', '.dropdown-menu a', toggleDropdown);
/* not needed, prevents page reload for SO example on menu link clicked */
//$('.dropdown a').on('click tap', e => e.preventDefault());
/** END ON HOVER DROPDOWN MENU */

$(document).ready(function() {

  /**
   * Is Mac os, Firefox, Opera, Safari, IE-10, IE-11, IE-Edge, lt-ie-10 (ie-9,8,7,6...)
   * https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
   * @description  add additional class on html if mac os.
   */
  if (navigator.platform.match(/(Mac)/i)) $html.addClass("mac-os");
  if (isFirefox) $html.addClass("firefox");
  if (isOpera) $html.addClass("opera");
  if (isSafari) $html.addClass("safari");
  if (isChrome) $html.addClass("chrome");

  if (isIE) {
    if (isIE < 10) {
      $html.addClass("lt-ie-10");
    }

    if (isIE < 11) {
        $html.addClass("ie-10");
    }

    if (isIE === 11) {
      $("html").addClass("ie-11");
    }

    if (isIE === 12) {
      $("html").addClass("ie-edge");
    }
  }

  // Custom
  var stickyToggle = function(sticky, stickyWrapper, scrollElement) {
    var stickyHeight = sticky.outerHeight();
    var stickyTop = stickyWrapper.offset().top;
    if (scrollElement.scrollTop() >= stickyTop){
      stickyWrapper.height(stickyHeight);
      sticky.addClass("is-sticky");
    }
    else{
      sticky.removeClass("is-sticky");
      stickyWrapper.height('auto');
    }
  };

  // Find all data-toggle="sticky-onscroll" elements
  $('[data-toggle="sticky-onscroll"]').each(function() {
    var sticky = $(this);
    var stickyWrapper = $('<div>').addClass('sticky-wrapper'); // insert hidden element to maintain actual top offset on page
    sticky.before(stickyWrapper);
    sticky.addClass('sticky');

    // Scroll & resize events
    $(window).on('scroll.sticky-onscroll resize.sticky-onscroll', function() {
      stickyToggle(sticky, stickyWrapper, $(this));
    });

    // On page load
    stickyToggle(sticky, stickyWrapper, $(window));
  });

  // Scroll to top
  // ----------------------------------------------------------------

  /*var $wrapper = $('#app');
  $wrapper.append($("<div class='scroll-top'>gore</div>"));*/

  var $scrollbtn = $('.scroll-top');

  $(document).on('ready scroll', function () {
      var docScrollTop = $(document).scrollTop(),
          docScrollBottom = $(window).scrollTop() + $(window).height() == $(document).height();

      if (docScrollTop >= 150) {
          $scrollbtn.addClass('visible');
      } else {
          $scrollbtn.removeClass('visible');
      }
      if (docScrollBottom) {
          $scrollbtn.addClass('active');
      }
      else {
          $scrollbtn.removeClass('active');
      }
  });

  $scrollbtn.on('click', function () {
      $('html,body').animate({
          scrollTop: $('body').offset().top
      }, 1000);
      return false;
  });

});
